/**
 * @bref 依据poiid（国家id），获取不同的签证须知
 * @date 2017-07-07
 * */
var SchengenVisa = '此申根签证产品需本人亲自到使馆或签证中心采集指纹。';

var JapanVisa = '因办理日本签证的特殊性，下单后签证商家会视个人签证资料情况决定是否收取保证金。暂无法为福建省、青岛领区及居住在东北三省的用户提供日本签证服务。';

var SpainVisa = '因使馆预约位子有限，西班牙各个领区都会涉及到额外付费预约的情况，请在下单时知晓并二次确认，具体费用以下单后实拍链接金额为准。';

var CanadaVisa = '此签证产品需本人亲自到使馆或签证中心采集指纹。';

var MaltaVisa = '此申根签证产品需本人亲自到使馆或签证中心采集指纹。';

var IcelandVisa = '此申根签证产品需本人亲自到使馆或签证中心采集指纹。';


var visaInfo = {
  p_14829: CanadaVisa, //加拿大
  p_21833: MaltaVisa, //马耳他，也是申根
  p_21637: IcelandVisa, //冰岛，也是申根
  p_13489: SpainVisa,  //西班牙,同时也是申根
  p_22256: JapanVisa   //日本
};

var SchengenPid = [11600,21146,21147,21164,21174,11774,12552,21265,10065,21560,21561,21562,21570,21571,14198,21625,21626,21627,21634,21635,21636,21638,14315]; //其余的申根国家列表pid

_.each(SchengenPid, function(pid){
  visaInfo["p_"+pid] = SchengenVisa;
});

module.exports = (pid) => {return visaInfo['p_' + pid] ? visaInfo['p_' + pid] : ''}




/** WEBPACK FOOTER **
 ** ./script/conf/visa-hint-info.js
 **/